import { TemplateStage1Form } from './TemplateStage1Form';

export default TemplateStage1Form;